import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import urls from '../../constants/urls'
import { resolveRouteURL } from '../../utils/getURL'
import Sidebar from '../../components/Sidebar'
import { useCompanyId } from '../../hooks/useCompanyId'


export function HomeSidebar() {
    const location = useLocation()
    const companyId = useCompanyId()
    const { pathname } = location

    return (
        <Sidebar>
            <Sidebar.Item
                as={NavLink}
                to={resolveRouteURL(urls.PagePaths.HOME, { companyId })}
                selected={pathname.includes('/dashboard')}
                iconType="activity"
                right="Overview"
                title="Overview"
            />
        </Sidebar>
    )
}
